<template>
    <div class="main-box">
    <!-- <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" :visible.sync="dialogFormVisible" append-to-body="true" width="75%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="学生档案"> -->
        <div class="info-box">
           <el-image :src="'apigw/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id='+vo.id+'&httpPort='+httpPort" style="width:100px;height:100px;border-radius:10px;margin-right: 20px;"></el-image>
           <div style="flex:1">
               <div><span>{{ vo.name }}</span></div>
               <div style="display: flex;">
                   <div style="min-width:150px">学号：{{ vo.studentId }}</div><div style="min-width:200px">专业：{{ vo.majorName }}</div><div>班级：{{ vo.className }}</div>
               </div>
               <div style="display: flex;">
                   <div style="min-width:150px">学制：{{ filterEducationSystem(vo.educationSystem) }}</div><div>{{ filterStatus(vo.studentFileStatus) }}</div>
               </div>
           </div>
           <div>
               <div style="cursor:pointer;" @click="showCard"><span>学籍卡</span></div>
               <!-- <div><span>切换档案</span></div> -->
           </div>
        </div>

        <el-tabs v-model="activeTabName" style="width:100%;" @tab-click="changeTab">
            <el-tab-pane label="基本信息" name="User" />
            <el-tab-pane label="学费缴纳" name="Fee" />
            <el-tab-pane label="家庭成员" name="Family" />
            <el-tab-pane label="宿舍情况" name="Hostel" />
            <el-tab-pane label="考试成绩" name="Exam" />
            <el-tab-pane label="资助记录" name="Grant" />
            <el-tab-pane label="获奖情况" name="Award" />
            <el-tab-pane label="违规违纪" name="Violation" />
            <el-tab-pane label="请假记录" name="Leave" />
            <el-tab-pane label="毕业离校" name="Graduate" />
          </el-tabs>

        <div v-if="activeTabName==='User'">
            <InfoView :vo="vo" :can-edit="canEdit"></InfoView>
        </div>
        <div v-else-if="activeTabName=='Fee'">
            <FeeTable :vo="vo"></FeeTable>
        </div>
        <div v-else-if="activeTabName=='Family'">
            <FamilyTable :vo="vo" :can-edit="canEdit"></FamilyTable>
        </div>
        <div v-else-if="activeTabName=='Hostel'">
            <DormitoryTable :vo="vo">宿舍情况</DormitoryTable>
        </div>
        <div v-else-if="activeTabName=='Exam'">
            <EexamTable :vo="vo"></EexamTable>
        </div>
        <div v-else-if="activeTabName=='Grant'">
            <GrantTable :vo="vo"></GrantTable>
        </div>
        <div v-else-if="activeTabName=='Award'">
            <AwardTable :vo="vo"></AwardTable>
        </div>
        <div v-else-if="activeTabName=='Violation'">
            <ViolationTable :vo="vo"></ViolationTable>
        </div>
        <div v-else-if="activeTabName=='Leave'">
            <LeaveTable :vo="vo"></LeaveTable>
        </div>
        <div v-else-if="activeTabName=='Graduate'">
            <GraduateTable :vo="vo"></GraduateTable>
        </div>

        <!-- <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" fullscreen :visible.sync="dialogFormVisible" append-to-body="true" width="100%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" title="学籍卡">
            <studentCard :vo="vo"></studentCard>
        </el-dialog> -->
        <div class="el_dialog_footer">
            <el-button type="info" @click="canEdit=0">取消</el-button>
            <el-button type="primary" @click="canEdit=1">修改</el-button>
        </div>
    </div>
    <!-- </el-dialog> -->
</template>

<script>
//import StudentCard from './studentCard'
import InfoView from './table/infoView'
import FeeTable from './table/feeTable'
import EexamTable from './table/examTable'
import AwardTable from './table/awardTable'
import ViolationTable from './table/violationTable'
import LeaveTable from './table/leaveTable'
import GraduateTable from './table/graduateTable'
import GrantTable from './table/grantTable'
import FamilyTable from './table/familyTable'
import DormitoryTable from './table/dormitoryTable'
export default {
    components: {
        InfoView,
        FeeTable,
        EexamTable,
        AwardTable,
        ViolationTable,
        LeaveTable,
        GraduateTable,
        GrantTable,
        FamilyTable,
        //StudentCard,
        DormitoryTable
    },
    props: {
        vo: {}
    },
    data: function() {
        return {
            httpPort: location.port,
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/student/basicInfo/formCard.html', 'addNewUrl': 'xsgl/studentBasicInfo/addNew', 'insertUrl': 'xsgl/studentBasicInfo/insert', 'getByIdUrl': 'xsgl/studentBasicInfo/getById', 'updateUrl': 'xsgl/studentBasicInfo/update', 'delUrl': 'xsgl/studentBasicInfo/delete', 'listDataUrl': 'xsgl/studentBasicInfo/listdata', 'winWidth': 1200, 'winHeight': 600, 'moduleCode': 'basicInfo', 'openViewType': '0', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0, 'oldListDataUrl': '/xsgl/studentBasicInfo/listdata', 'busiFormTemplate': '/student/basicInfo/formCard'},
            dialogFormVisible: false,
            detail: {},
            canEdit: 0,
            activeTabName: 'User',
            graduateData: [],
            feeData: [],
            leaveData: [],
            examData: [],
            awardData: [],
            violationData: [],
            grantData: [],
            familyData: []
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    beforeDestroy: function() {
        this.$bus.$off('showStudentFormDialog')
    },
    mounted: function() {
        let _this = this
        _this.$bus.$on('showStudentFormDialog', (params) => {
            console.log('params', params)
            _this.type = params.type
            if (params) {
                _this.dialogFormVisible = true
            }
            if (params.type == 1) {
                _this.vo = {...params.detail}
            }
        })
    },
    methods: {
        showCard() {
            const formId = this.vo ? this.vo.id : ''
            window.open('#/newBusiForm?voId=' + formId + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo)) + '&title=&canEdit=false&busiInfo=学籍卡&formUrl=student.basicInfo.formCard&noEdit=true')
            //this.dialogFormVisible = true;
        },
        changeTab: function(val) {
            console.log('val', val)
            this.activeTabName = val.name
        },
        showTeacherFormDialog: function(val) {
            console.log('archiveInfo form opened')
        },
        filterEducationSystem(val) {
            if (val == 1) {
                return '二年'
            } else if (val == 2) {
                return '三年'
            } else if (val == 3) {
                return '四年'
            } else if (val == 4) {
                return '五年'
            } else if (val == 5) {
                return '六年'
            }
        },
        filterStatus(val) {
            if (val == 0) {
                return '在籍在校'
            } else if (val == 1) {
                return '在籍离校'
            } else if (val == 2) {
                return '未激活'
            } else if (val == 3) {
                return '已离校'
            } else if (val == 4) {
                return '在籍不在校'
            }
        }
    }
}
</script>

<style scoped>
.main-box {
    padding: 20px;
}
.info-box {
    padding-bottom: 20px;
    font-size: 14px;
    display: flex;
    line-height: 30px;
}
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.el-tabs__header {
    width: 90% !important;
}
.el_dialog_footer {
    display: flex;
    justify-content: center;
    padding-top: 20px;
}
</style>
